export const extractReputationLevel = (reputationType) => {
  if (!reputationType) {
    return null;
  }

  const level = reputationType.match(/\d+$/);
  return level ? parseInt(level[0], 10) : null;
};
